import axiosInstance from '../../../helpers/backend_helper';

const updateAmazonBook = async ({id, name, amazon_link, amazon_link_uk, image}) => {
  try {
    const formData = new FormData();
    name && formData.append('name', name);
    amazon_link && formData.append('amazon_link', amazon_link);
    amazon_link_uk && formData.append('amazon_link_uk', amazon_link_uk);
    image && formData.append('image', image);

    const response = await axiosInstance.post(`books/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error updating Amazon book:', error);
    throw error;
  }
};

export default updateAmazonBook;
